module.exports = __webpack_public_path__ + "files/d31183120d7262f65868ae174ffcfca6.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/roboto-bold-webfont.woff2
 ** module id = 999
 ** module chunks = 0
 **/